import axios from "axios";
import axiosInstance from "../axiosInstance";
const BASE_URL = process.env.REACT_APP_API_URL;
const STAGE = process.env.REACT_APP_API_STAGE;

export const postEmployee = async (payload: any) => {
  try {
    const response = await axiosInstance.post(
      BASE_URL + `v1/${STAGE}/dashboard/employee-post`,
      payload
    );
    return response.data;
  } catch (error) {
    console.log(error);
    console.log(axios.AxiosError);
  }
};

export const getEmployeeReport = async () => {
  try {
    const response = await axiosInstance.get(
      BASE_URL + `v1/${STAGE}/dashboard/employees`
    );
    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const getEmployeeTemplate = async () => {
  try {
    const response = await axiosInstance.get(
      BASE_URL + `v1/${STAGE}/dashboard/employee-template`
    );
    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const detailEmployeeApi = async (payload: any) => {
  try {
    const response = await axiosInstance.get(
      BASE_URL + `v1/${STAGE}/dashboard/employee-id/${payload._id}`
    );

    // console.log(response.data);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getEmployeeApi = async () => {
  try {
    const response = await axiosInstance.get(
      BASE_URL + `v1/${STAGE}/dashboard/employees-person/`
    );

    // console.log(response.data);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const uploadEmployeeApi = async (payload: any) => {
  try {
    const response = await axiosInstance.post(
      BASE_URL + `v1/${STAGE}/dashboard/upload-employees`,
      payload,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );

    // console.log(response.data);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const updateEmployeeApi = async (payload: any) => {
  try {
    const response = await axiosInstance.post(
      BASE_URL + `v1/${STAGE}/dashboard/upload-employees-update`,
      payload,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );

    // console.log(response.data);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const deleteDataEmployeeApi = async (payload: any) => {
  try {
    const response = await axiosInstance.post(
      BASE_URL + `v1/${STAGE}/dashboard/employee-delete`,
      payload
    );

    // console.log(response.data);
    return response.data;
  } catch (error) {
    throw error;
  }
};
